import React, { useMemo } from 'react';

import { Dropdown, Footer, Header } from '@els/els-react--leyden';

import useAuth from 'hooks/useAuth';
import 'assets/scss/components/layout/AppLayout.scss';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const { user, logout } = useAuth();

  const fullName = user ? [user.profile.given_name, user.profile.family_name].filter(Boolean).join(' ') || null : null;

  const accountOptions = useMemo(() => [{ label: 'Sign out', onClick: () => logout() }], [logout]);

  return (
    <div className="app-shell">
      <Header wordmark="Compass Coach">
        {fullName && (
          <div className="header-account">
            <Dropdown id="header-account-menu" showSelectedAsLabel options={accountOptions} showIcon={false} flyoutProps={{ placement: 'bottom-end' }} label={fullName} />
          </div>
        )}
      </Header>
      <main className="main-content">{children}</main>
      <Footer legalEntity="Elsevier Inc." monochromeLogo />
    </div>
  );
};

export default AppLayout;
